import React from "react";

import { ResourceAvatar } from "@common/resourceAvatar";
import { RemoveIcon } from "@common/assets/removeIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function Resource({ resource, remove }: Props) {
  return (
    <div className={styles.resource} onClick={() => remove(resource)}>
      <div className={styles.user}>
        <div className={styles.avatar}>
          <ResourceAvatar resource={resource} />
        </div>
        <p className={styles.name}>{resource.name}</p>
      </div>
      <div className={styles.removeIconContainer}>
        <RemoveIcon className={styles.icon} />
      </div>
    </div>
  );
}

export { Resource };
